// extracted by mini-css-extract-plugin
module.exports = {"no-image-message":"ImageUploadComponent_no-image-message__1huIE"};